// import vm from '../main'
// const internals = {}

// internals.getRegions = function(params) {

//     let regionId
//     return this.$regionDataRepository.list(params)
//         .then((response) => {
//             this.regionData =
//                 response.data &&
//                 response.data.docs &&
//                 response.data.docs.filter(item => item.regionManager == this.user._id);

//             this.regionId = this.regionData && this.regionData.map(item => item._id)

//             this.params = {
//                 ...this.params,
//                 region: this.regionId[0],
//             };
//         })
// }

// export default internals


// WEBPACK FOOTER //
// ./src/services/filter.service.js